var _defs, _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEltaskyline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Calque_2",
    "data-name": "Calque 2",
    viewBox: "0 0 968.85 95.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#1c1e21;stroke:#1c1e21;stroke-miterlimit:10;}"))), /*#__PURE__*/React.createElement("g", {
    id: "layer2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1028.84,194.3H-.82L-.92,70.88C6,65.2,11,58.31,15.52,51.09A47.2,47.2,0,0,0,30.66,64.52c8.57-8.61,11.61-15.06,16.52-22.24,7.49,13,15.53,25.36,26.47,34.73a38.24,38.24,0,0,0,9.58-10.69c3.24,3.41,6.5,6.73,10.22,8.11,1.34-12.52,2.66-25,.59-38.58,9-1.63,18.12-2,27.62.5-.18.75-2.23,15.38-.18,21.15,4.11-2.8,6.28-8.09,8.43-13.42,2.41,7.79,5.67,15.07,10.57,21.31,10.47-4.31,18.5-2.07,26.53.2,0,8.82-.77,14,.06,19.26a41.34,41.34,0,0,0,7.47-7.29,45.14,45.14,0,0,0,19,13.25,98.54,98.54,0,0,0,0-18.34l2,.14a9.45,9.45,0,0,0,.06-5.23l-2.24.19a107,107,0,0,0,21.39-30.18c7.42,10.4,14.26,21.38,24.38,29,.16-2-.08-5,1.55-8.31,8.42-2,20.55-3.26,31.08-.89,1.86,3.87,1.47,6.19,1.26,8.64,4.24-4.45,6.22-8.9,8.53-13.34,3.8,8.13,8,15.93,13.83,22.52a29.3,29.3,0,0,0,17-6.66,7.69,7.69,0,0,1-.1-4.59l-3.4-.6c13.73-5.68,25.25-14.41,36-24.21l1.24.44a3.86,3.86,0,0,0-.15-3.27c-1-.84-2.31-.1-3.49,0,7.54-6.48,12-14.23,18.09-22.9C366.51,21.69,370,28,378.09,35.74c-1.36-.31-2.71-.73-4.07.21a57,57,0,0,0-.24,15.8c14.42,1.3,26.45,1.84,40.87.93a29.18,29.18,0,0,0,.07,13.53l-1.62,0a32.45,32.45,0,0,0,0,14.36c28.08-11.87,50-10.7,68.89,1.61,1.47-3.35,3-7.56,2.51-11.42a5.6,5.6,0,0,1-2.55-.68V68.92A138.51,138.51,0,0,0,511.14,41c5.1,5.68,10.22,11.38,16.32,16.05,10.3-9.23,17.65-21,25-32.76,8.16,15.6,17,30.31,27.65,42.81l-2.6.49.94,1.64c4.87,2,7.57.27,11.1-.07a39.55,39.55,0,0,0,.2-10.94c-2.42-6.9-1.66-10.09,0-13.92.08-.17-.38-.54-.56-1.05a2.91,2.91,0,0,1,0-1.18c0-.75,1.08-.37,1.08-.58v-.68a66.53,66.53,0,0,1,17.55,0c.07.3,0,.55.11.84s.82.27,1,.54,0,1-.09,1.26-.6.65-.54,1c1,4.68,1.78,8.84-.55,14.09-.91,6.88-1,9.48.3,17.76,5.52,0,11.1-.08,15.78-1.1a5.43,5.43,0,0,0,0,1.62,2.2,2.2,0,0,1,2.15.07,62.74,62.74,0,0,0,.15-14c6.06-2.42,15.34-1.7,22.78.25-.7,7.37-.87,14,.54,18.44a31.65,31.65,0,0,1,13.94.24,12.88,12.88,0,0,1,1.18-7.58l-3.35-.39c11.2-6.86,21-14.93,30.56-24a90,90,0,0,0,12.89,16.91l.22-1.62,4.52.15,2.62.07c3.23.08,6.44.09,9.67-.11v1.37c1.61.13,2-1.48,2.58-2.74l1.81,4.7c.2.42.41.84.61,1.25,2.71,5.64,4.63,10.2,6.84,8.3a178,178,0,0,0,21.71-22.66c5.91,7.32,11.84,14,17.77,18.42v2.87l-3.94,0c.45,1.73,1.34,3.57,0,4.83,5.32.32,8.59.16,14.36,0-1.34-1.93-.8-4.23.23-6.65l-4.57-.53A134.08,134.08,0,0,0,793.91,46c1.75,4.19,2.5,10.36,6.54,12.65.89-4.87,2.58-13,.34-20.18l-2.12-.37,0-2.77,2.09-.41.08-2.62c11.33-2.89,21.3-1.58,31.22-.1l.38,2.78,2.55.33-.52,2.79h-2c-.27,4.64-1.19,8.5,1.89,19.31,2.17-.46,4.45-.41,6.16-2.75l.54-6h-3c10.74-10.47,18.46-22.27,25.9-34.2,7.8,12.79,14.2,23.77,24.28,32.1.84.64-.47,0-4.48-.16-.5,1.64-.9,2.92,0,4.56h2.33c1.37,1.86.81,3.72-.18,5.58h-1.79c-.94,4.74-1.76,9.47-.36,14.21C891.64,64,897,53.92,902.05,43.32c2.84,4.27,4.63,9.06,7,11.83,2.2-8.48.53-17.62.08-26.56a69,69,0,0,1,9.94-1.24c.67-.05,1.33-.08,2-.09.35,0,.7,0,1.06,0,.72,0,1.44,0,2.17,0,.35,0,.71,0,1.08,0,.7,0,1.41,0,2.11.07,2.87.13,5.72.4,8.56.75l-1,5.79c8.81-9.29,14.78-20.93,21.32-32.1,5.52,16.76,15.69,30.9,26.4,44.72l-5.58-1.3c-.37,6.69-1.82,13.6,0,19.84,5.88-2.81,11.34-1.73,16.76-.13.94-11,1.41-23.55,1.52-36,.06-5.37,0-10.48,0-14.83h33.2Q1028.77,104.16,1028.84,194.3Z",
    id: "path8",
    style: {
      fill: "#121212",
      fillOpacity: 1
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "path7347",
    className: "cls-1",
    cx: 957.24,
    cy: 75.4,
    rx: 1.2,
    ry: 1.06
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "path7349",
    className: "cls-1",
    cx: 957.24,
    cy: 73.32,
    rx: 0.76,
    ry: 0.84
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "path7351",
    className: "cls-1",
    cx: 957.19,
    cy: 72.35,
    rx: 0.09,
    ry: 1.99
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path7377",
    className: "cls-1",
    d: "M922.34,22.9l-.26,6.1,2.22.09.09-6.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path7379",
    className: "cls-1",
    d: "M925.72,23l-.45,6.1L927.5,29l.09-6.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path7381",
    className: "cls-1",
    d: "M921.1,22.9v5.75l-2.05-.27.27-5.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path7383",
    className: "cls-1",
    d: "M743.63,53.69s-3.24,4.24-2.83,3.9,7.58-1.85,7.58-1.85Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path7385",
    className: "cls-1",
    d: "M743.73,57.89l-.11,4.54L746,62.2l-.12-4.42Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path7387",
    className: "cls-1",
    d: "M744.33,62.31,745.9,61l-2.35,1.41,2.69,3,2-2.22L745.9,61l-1,.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path7389",
    className: "cls-1",
    d: "M746.15,58.25c1.13-.64,1.29-2.72,1.29-2.72v.32"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path7391",
    className: "cls-1",
    d: "M742.93,56.65l-.64.48.16,1,1,.48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path7393",
    className: "cls-1",
    d: "M709.42,67.1l.38-14.5,2.51.25-.25,14.75Z"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "path7399",
    className: "cls-1",
    d: "M352.34,19.4l-14.58-6.61"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "path7397",
    className: "cls-1",
    d: "M350.92,15.78l-.29,21.3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path7401",
    className: "cls-1",
    d: "M339.51,11.91l-2.14,3.42"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path7403",
    className: "cls-1",
    d: "M341.52,12.94l-2.31,3.45"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path7403-7",
    className: "cls-1",
    d: "M343.92,14l-2.31,3.45"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path7401-8",
    className: "cls-1",
    d: "M346.17,15.21,344,18.62l.05.14"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path7403-4",
    className: "cls-1",
    d: "M348.18,16.24l-2.31,3.45"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path7403-7-5",
    className: "cls-1",
    d: "M350.58,17.32l-2.31,3.45"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path7403-1",
    className: "cls-1",
    d: "M352.4,18.31l-2.32,3.46"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path7399-2",
    "data-name": "path7399",
    className: "cls-1",
    d: "M163,52.87l-14.58,6.61"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path7397-2",
    "data-name": "path7397",
    className: "cls-1",
    d: "M150.1,77.16l-.29-21.31"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path7401-2",
    "data-name": "path7401",
    className: "cls-1",
    d: "M163.36,55.4,161.22,52"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path7403-2",
    "data-name": "path7403",
    className: "cls-1",
    d: "M161.52,56.47,159.21,53"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path7403-7-2",
    "data-name": "path7403-7",
    className: "cls-1",
    d: "M159.12,57.55l-2.31-3.45"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "path7401-8-2",
    "data-name": "path7401-8",
    className: "cls-1",
    d: "M156.65,58.84l0-.14-2.14-3.41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path7403-4-2",
    "data-name": "path7403-4",
    className: "cls-1",
    d: "M154.86,59.77l-2.31-3.46"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "path7403-7-5-2",
    "data-name": "path7403-7-5",
    className: "cls-1",
    d: "M152.46,60.85l-2.31-3.46"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "path7403-1-2",
    "data-name": "path7403-1",
    className: "cls-1",
    d: "M150.65,61.84l-2.32-3.45"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "path7383-2",
    "data-name": "path7383",
    className: "cls-1",
    d: "M62.47,52.73c.4.33-2.82-3.9-2.82-3.9l-4.72,2.05"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "path7383-3",
    "data-name": "path7383",
    className: "cls-1",
    d: "M54.93,50.88s7.13,1.52,7.54,1.85"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "path7385-2",
    "data-name": "path7385",
    className: "cls-1",
    d: "M57.4,52.92l-.11,4.42,2.38.23L59.56,53Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "path7387-2",
    "data-name": "path7387",
    className: "cls-1",
    d: "M58.35,56.74l-1-.6-2.33,2.21"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "path7387-3",
    "data-name": "path7387",
    className: "cls-1",
    d: "M55.07,58.35l2,2.21"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "path7387-4",
    "data-name": "path7387",
    className: "cls-1",
    d: "M57,60.66l2.67-3L57,57.17l-1.91,1.2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "path7389-2",
    "data-name": "path7389",
    className: "cls-1",
    d: "M55.86,51v-.33s.58,2.22,1.7,2.86"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "path7391-2",
    "data-name": "path7391",
    className: "cls-1",
    d: "M59.41,53.94l1.42-.71.16-1-.64-.48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEltaskyline);
export default __webpack_public_path__ + "static/media/eltaskyline.038b7e90e37e9d0fd818b1ce67c8c901.svg";
export { ForwardRef as ReactComponent };